// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".f1Wuw,._8VLSo{display:flex}.f1Wuw{width:100%;flex:1;flex-direction:column}.tx4yk._8VLSo{color:#fff}.QMFle._8VLSo{color:#2d2d2d}.qLEUb{width:80px;height:80px;margin-right:16px;background-color:#2d2d2d;border-radius:4px;-o-object-fit:cover;object-fit:cover}@media screen and (min-width:768px){.qLEUb{width:120px;height:120px;margin-right:24px}}.sIuEp{margin:0 0 4px;font-size:20px;font-style:normal;font-weight:700;line-height:24px}@media screen and (min-width:768px){.sIuEp{margin-bottom:8px}}@media screen and (min-width:1552px){.sIuEp{font-size:18px}}.yzH0f{margin:0 0 20px;font-size:15px;line-height:22px}@media screen and (min-width:1552px){.yzH0f{max-width:432px}}._5Ra8D{display:flex;align-items:center;justify-content:space-between}._8VLSo .zvo2\\+{display:none}@media screen and (min-width:768px){._8VLSo .zvo2\\+{display:inherit}}.rRHyl{display:flex;flex-wrap:wrap;align-items:center;padding:0;margin:0;font-size:13px;line-height:20px;list-style:none}@media screen and (min-width:768px){.rRHyl{font-size:14px;line-height:24px}}.tx4yk .rRHyl{color:#989898}.QMFle .rRHyl{color:#767676}.FAkRj:not(:first-child):before{margin:0 8px;content:\"·\"}.FAkRj.sD3RG{color:#f02d37}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"info": "f1Wuw",
	"podcastItemHeader": "_8VLSo",
	"dark": "tx4yk",
	"light": "QMFle",
	"image": "qLEUb",
	"title": "sIuEp",
	"description": "yzH0f",
	"footer": "_5Ra8D",
	"readMore": "zvo2+",
	"entries": "rRHyl",
	"entry": "FAkRj",
	"isPartner": "sD3RG"
};
module.exports = ___CSS_LOADER_EXPORT___;
